/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import { Container } from "../components/ui";
import Post from "../components/common/post";
import { getEducationalPosts } from "../api";
import { Link } from "react-router-dom";
import Pagination from "../components/common/Pagination";
import NoResultsFound from "./NoResultsFoundTemplate";
import { DotLoader } from "react-spinners";
import { withRouter } from "../hooks/withRouter";

class SearchResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      total: 0,
      activePage: 1,
      loading: true,
    };
  }

  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  componentWillUnmount = () => {
    document.removeEventListener("scroll", this.trackScrolling);
  };

  handlePageChange = async (pageNumber) => {
    this.setState({ activePage: pageNumber });
    const { state } = this.props.location || {};
    let term = "";
    if (state) {
      term = state.term;
    }
    let filter = {
      authorIds: [],
      educationOnly: false,
      searchString: term,
      applySearchStringTo: {
        title: true,
        content: false,
        excerpt: false,
        tags: true,
      },
    };
    const posts = await getEducationalPosts(filter, 7, pageNumber - 1);
    this.setState(
      {
        posts: posts.data.items,
      },
      () => {
        window.scrollTo(0, 0);
      }
    );
  };

  componentDidMount = async () => {
    this.setState({ loading: true });
    const { state } = this.props.location || {};
    let term = "";
    if (state) {
      term = state.term;
    }
    let filter = {
      authorIds: [],
      educationOnly: false,
      searchString: term,
      applySearchStringTo: {
        title: true,
        content: false,
        excerpt: false,
        tags: true,
      },
    };
    document.addEventListener("scroll", this.trackScrolling);
    const posts = await getEducationalPosts(filter, 7, 0);
    this.setState({
      posts: posts ? posts.data.items : [],
      total: posts ? posts.data.total : 0,
      loading: false,
    });
  };

  componentDidUpdate = async (prevProps, prevState) => {
    if (
      prevProps.location?.state &&
      this.props.location?.state &&
      prevProps.location.state.term !== this.props.location.state.term
    ) {
      this.setState({ loading: true });
      const { state } = this.props.location || {};
      let term = "";
      if (state) {
        term = state.term;
      }
      let filter = {
        authorIds: [],
        educationOnly: false,
        searchString: term,
        applySearchStringTo: {
          title: true,
          content: false,
          excerpt: false,
          tags: true,
        },
      };
      const posts = await getEducationalPosts(filter, 10, 0);
      this.setState({
        posts: posts ? posts.data.items : [],
        total: posts ? posts.data.total : 0,
        loading: false,
      });
    }
  };

  render() {
    const { state } = this.props.location;
    let term = "";
    if (state) {
      term = state.term;
    }
    return (
      <Container style={{ padding: "0px 10px" }}>
        {this.state.loading ? (
          <div className="mainLoaderBlock">
            <DotLoader color="#36d7b7" />
            <label style={{ marginTop: 30 }}>Loading your content...</label>
          </div>
        ) : Array.isArray(this.state?.posts) && this.state.posts.length > 0 ? (
          <>
            <h4
              style={{
                color: "#3D5170",
                padding: "45px 0px 30px 235px",
                fontWeight: 600,
                fontSize: 26,
              }}
            >
              {`Search Results for: ${term}`}{" "}
            </h4>
            <div
              style={{
                margin: window.screen.width > 768 ? "0% 21%" : "0% 5%",
                borderLeft: "1px solid #ebebeb",
                borderRight: "1px solid #ebebeb",
                padding: window.screen.width > 768 ? "0px 55px" : "0px 0px",
              }}
              id={"post-wrapper"}
            >
              {Array.isArray(this.state?.posts) &&
                this.state.posts.length > 0 &&
                this.state?.posts?.map((post, idx) => (
                  <>
                    <Link
                      to={`/analyst/${post.author.slug}`}
                      className="card-post__author-avatar card-post__author-avatar--small"
                      style={{
                        backgroundImage: `url('${post.author.avatar.small}')`,
                        zIndex: 10,
                        width: window.screen.width > 768 ? 65 : 40,
                        height: window.screen.width > 768 ? 65 : 40,
                        position: "absolute",
                        marginLeft:
                          window.screen.width > 768 ? "-90px" : "-19px",
                      }}
                    ></Link>
                    <Post key={idx} col={"12"} post={post} />
                  </>
                ))}
              <label className="pagelabel">
                Page {this.state.activePage} of{" "}
                {Math.ceil(this.state.total / 7)}
              </label>
            </div>
            <div
              className="paginationDiv"
              style={{
                display: "flex",
                margin: window.screen.width > 768 ? "0% 21%" : "0% 5%",
                borderRight: "1px solid rgb(235, 235, 235)",
              }}
            >
              <Pagination
                itemClass="page-item"
                linkClass="page-link"
                activePage={this.state.activePage}
                itemsCountPerPage={7}
                totalItemsCount={this.state.total}
                pageRangeDisplayed={window.screen.width < 500 ? 1 : 3}
                onChange={this.handlePageChange.bind(this)}
                hideDisabled={true}
              />
            </div>
          </>
        ) : (
          <NoResultsFound />
        )}
      </Container>
    );
  }
}

export default withRouter(SearchResults);
